
export const env = window.location.host.indexOf('app.chuanfu.ltd') > -1 ? 'product' : 'dev';

export const apiPrefix = '/api/v1';

export const imgPrefix = env == 'product' ? 'https://cfproject.chuanfu.ltd/' : 'http://localhost:9013/';

export const adminTypes = { 1: '超级管理员', 2: '普通管理员'};

export const appId = env == 'product' ? 'wx74e232c0747e54dc' : 'wx74e232c0747e54dc';//wx86fe4e33c7297319=柏视野公众号，目前就先用这个测试  wx74e232c0747e54dc==正式的永丰环保餐饮服务
